import { render } from "./CommandPalette.vue?vue&type=template&id=39d8d434"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"

import "./CommandPalette.vue?vue&type=style&index=0&id=39d8d434&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__